var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { DownloadTimeCategory } from "./downloadConstants";
import { Accordion } from "react-bootstrap";
import DownloadCard from "./DownloadCard";
import di from "../Downloads/downloadDI/servicelocator";
import { base64toExcel } from "@frameworks/salesjourney/utils/genericMethods";
import moment from "moment";
import Loader from "../../../../shared-library/components/Loader";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
import CustomPagination from "../../../../shared-library/components/CustomPagination";
var DownloadByCategory = function (props) {
    var _a, _b;
    var _c = __read(useState(undefined), 2), downloadListData = _c[0], setDownloadListData = _c[1];
    var _d = __read(useState(undefined), 2), searchList = _d[0], setSearchList = _d[1];
    var _e = __read(useState(false), 2), loader = _e[0], setLoader = _e[1];
    function getDateByCategory(category) {
        var now = new Date();
        var date;
        switch (category) {
            case DownloadTimeCategory.TODAY:
                date = now;
                break;
            case DownloadTimeCategory.YESTERDAY:
                date = new Date(now);
                date.setDate(now.getDate() - 1);
                break;
            case DownloadTimeCategory.EARLIER_THIS_WEEK:
                date = new Date(now);
                var dayOfWeek = date.getDay();
                var daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
                date.setDate(now.getDate() - daysToSubtract);
                break;
            case DownloadTimeCategory.TWO_WEEKS_AGO:
                date = new Date(now);
                date.setDate(now.getDate() - 14);
                break;
            case DownloadTimeCategory.EARLIER_THIS_MONTH:
                date = new Date(now.getFullYear(), now.getMonth(), 1);
                break;
        }
        return moment(date).format("YYYY/MM/DD");
    }
    var downloadFile = function (file) {
        di.downloads
            .downloadFile({ fileId: file.fileId.toString() })
            .then(function (resp) {
            if (resp === null || resp === void 0 ? void 0 : resp.base64String) {
                base64toExcel(resp === null || resp === void 0 ? void 0 : resp.base64String, file === null || file === void 0 ? void 0 : file.fileName);
            }
        })
            .catch(function (error) {
            console.log("error", error);
        });
    };
    var getDownloadList = function (page) {
        setLoader(true);
        di.downloads
            .getDownloadPageList({
            page: page ? page.toString() : "1",
            pageSize: "10",
            filename: props === null || props === void 0 ? void 0 : props.searchText,
            FromDate: props.dateCategory === DownloadTimeCategory.OLDER
                ? ""
                : getDateByCategory(props.dateCategory),
            ToDate: props.dateCategory === DownloadTimeCategory.OLDER
                ? getDateByCategory(DownloadTimeCategory.EARLIER_THIS_MONTH)
                : props.dateCategory === DownloadTimeCategory.YESTERDAY
                    ? getDateByCategory(DownloadTimeCategory.YESTERDAY)
                    : getDateByCategory(DownloadTimeCategory.TODAY),
        })
            .then(function (resp) {
            var _a;
            if (((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setDownloadListData(resp);
                setSearchList(resp);
            }
            else {
                setDownloadListData(undefined);
            }
            setLoader(false);
        })
            .catch(function (error) {
            console.log("error", error);
            setLoader(false);
            setDownloadListData(undefined);
        });
    };
    useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.openAccd) || (props === null || props === void 0 ? void 0 : props.showToday) === (props === null || props === void 0 ? void 0 : props.dateCategory)) {
            var getData_1 = setTimeout(function () {
                getDownloadList();
            }, 800);
            return function () { return clearTimeout(getData_1); };
        }
    }, [props === null || props === void 0 ? void 0 : props.searchText]);
    useEffect(function () {
        if (props === null || props === void 0 ? void 0 : props.openAccd) {
            getDownloadList();
        }
    }, [props === null || props === void 0 ? void 0 : props.openAccd]);
    useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.showToday) === (props === null || props === void 0 ? void 0 : props.dateCategory)) {
            getDownloadList();
        }
    }, []);
    return (React.createElement(Accordion.Body, null,
        React.createElement("div", { className: "position-relative" },
            loader ? React.createElement(Loader, { className: "download-category-loader" }) : React.createElement(React.Fragment, null),
            ((_a = downloadListData === null || downloadListData === void 0 ? void 0 : downloadListData.data) === null || _a === void 0 ? void 0 : _a.length) > 0 ? ((_b = downloadListData === null || downloadListData === void 0 ? void 0 : downloadListData.data) === null || _b === void 0 ? void 0 : _b.map(function (obj) {
                return (React.createElement(DownloadCard, { statusText: obj.statusValue, deliveryTime: obj.requestDateTime, text: obj.fileName, showReset: false, 
                    // onClick={() => {
                    //   downloadFile(obj);
                    // }}
                    downloadFile: downloadFile, fileInfo: obj }));
            })) : (React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Data Found", displayType: ErrorDisplayType.INSECTION })),
            React.createElement(CustomPagination, { totalPages: downloadListData === null || downloadListData === void 0 ? void 0 : downloadListData.totalpages, getData: function (pageNumber) {
                    getDownloadList(pageNumber);
                }, bubbleClassName: null, activePageClassName: null, parentClassName: "d-flex DMSanN_14_400 justify-content-end pagination-container", currentPage: downloadListData === null || downloadListData === void 0 ? void 0 : downloadListData.currentpage }))));
};
export default DownloadByCategory;
